var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossWhite = function SvgCrossWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24.08 23.72"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.08v23.72H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#cross-white_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.07.71 22.3 22.3M23.01.71.71 23.01",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2
    }
  })));
};
export default SvgCrossWhite;